"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypes = exports.TaskStates = exports.TaskFrequency = void 0;
var TaskFrequency;
(function (TaskFrequency) {
    TaskFrequency["once"] = "once";
    TaskFrequency["daily"] = "daily";
    TaskFrequency["weekly"] = "weekly";
    TaskFrequency["monthly"] = "monthly";
})(TaskFrequency || (exports.TaskFrequency = TaskFrequency = {}));
var TaskStates;
(function (TaskStates) {
    TaskStates["scheduled"] = "scheduled";
    TaskStates["running"] = "running";
    TaskStates["paused"] = "paused";
    TaskStates["stopped"] = "stopped";
    TaskStates["completed"] = "completed";
    TaskStates["failed"] = "failed";
})(TaskStates || (exports.TaskStates = TaskStates = {}));
var TaskTypes;
(function (TaskTypes) {
    TaskTypes["sendings:bulk"] = "sendings:bulk";
    TaskTypes["payments:recurrent"] = "payments:recurrent";
    TaskTypes["billings:operations"] = "billings:operations";
})(TaskTypes || (exports.TaskTypes = TaskTypes = {}));
//# sourceMappingURL=tasks.enum.js.map